import * as actionTypes from "../actionTypes/actionTypes";
import {
  getDataDescriptionsService,
  createNewDataDescriptionService,
  deleteDataDescriptionService,
  getConfigService,
  saveDataDescriptionService,
  createNewConfigService,
  deleteDDValueService,
  createNewDDValueService,
  saveDDValueService,
} from "../services/DataDescsService";

const getDataDescriptions = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_DDS,
    });
    window.startLoading();
    getDataDescriptionsService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.GET_DDS_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_DDS_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const deleteDataDescription = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_DD,
    });
    window.startLoading();
    deleteDataDescriptionService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.DELETE_DD_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_DD_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const createNewDataDescription = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_DD,
    });
    window.startLoading();
    await createNewDataDescriptionService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_DD_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_DD_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const updateDataDescription = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_DD,
    });
    saveDataDescriptionService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_DD_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_DD_FAILURE,
          payload: error,
        });
      });
  };
};

const getConfigGroups = (requestPayload, callback = () => {}) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_CONFIG,
    });
    getConfigService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.GET_CONFIG_SUCCESS,
          payload: data,
        });
        callback();
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_CONFIG_FAILURE,
          payload: error,
        });
      });
  };
};

const saveSortedConfigGroups = (data) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_CONFIG_SUCCESS,
      payload: [...data],
    });
  };
};

const createNewConfig = (requestPayload, callback = undefined) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_DD,
    });
    createNewConfigService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_DD_SUCCESS,
          payload: data,
        });
        if (callback) callback();
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_DD_FAILURE,
          payload: error,
        });
      });
  };
};

//DD Values
const deleteDDValue = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_DD_VALUE,
    });
    deleteDDValueService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.DELETE_DD_VALUE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_DD_VALUE_FAILURE,
          payload: error,
        });
      });
  };
};

const createNewDDValue = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_DD_VALUE,
    });
    await createNewDDValueService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_DD_VALUE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_DD_VALUE_FAILURE,
          payload: error,
        });
      });
  };
};

const updateDDValue = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_DD_VALUE,
    });
    saveDDValueService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_DD_VALUE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_DD_VALUE_FAILURE,
          payload: error,
        });
      });
  };
};

export {
  getDataDescriptions,
  deleteDataDescription,
  createNewDataDescription,
  updateDataDescription,
  getConfigGroups,
  createNewConfig,
  deleteDDValue,
  createNewDDValue,
  updateDDValue,
  saveSortedConfigGroups
};
